// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.91.0-next',
  revision: 'f35eba21e',
  branch: 'next',
  date: 'Wed, 30 Sep 2026 14:40:18 GMT'
};